import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService } from "app/core/authentication/services";

@Component({
  selector: "cz-mfa",
  templateUrl: "./mfa.component.html",
  styleUrls: ["./mfa.component.scss"],
})
export class MFAComponent implements OnInit, OnDestroy {
  public mfaForm: FormGroup;
  public mfaCode: FormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(6),
    Validators.maxLength(6),
  ]);
  public resendDisabled = false;
  public resendCountdown = 60;
  private countdownTimer: any;

  constructor(
    private dialogRef: MatDialogRef<MFAComponent>,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: { userId: number }
  ) {
    this.mfaForm = new FormGroup({
      code: this.mfaCode,
    });
  }

  ngOnInit() {
    this.generateCode();
  }

  public validateCode(): void {
    if (this.mfaForm.valid) {
      this.authService
        .validateMFACode(this.data.userId, this.mfaCode.value)
        .subscribe(
          (isValid: boolean) => {
            if (isValid) {
              this.dialogRef.close(true);
            } else {
              this.mfaCode.setErrors({ invalid: true });
            }
          },
          (error) => {
            this.mfaCode.setErrors({ invalid: true });
          }
        );
    }
  }

  public generateCode(): void {
    if (!this.resendDisabled) {
      this.authService.generateMFACode(this.data.userId).subscribe(
        () => {
          this.startResendTimer();
        },
        (error) => {
          // Handle error
        }
      );
    }
  }

  private startResendTimer(): void {
    this.resendDisabled = true;
    this.resendCountdown = 60;

    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }

    this.countdownTimer = setInterval(() => {
      this.resendCountdown--;
      if (this.resendCountdown === 0) {
        this.resendDisabled = false;
        clearInterval(this.countdownTimer);
      }
    }, 1000);
  }

  ngOnDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
}
